import { render, staticRenderFns } from "./ClientAttachFilesWarningModal.vue?vue&type=template&id=b2788d14&scoped=true"
import script from "./ClientAttachFilesWarningModal.vue?vue&type=script&lang=js"
export * from "./ClientAttachFilesWarningModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2788d14",
  null
  
)

export default component.exports